module.exports = function() {
  return new Worker(__webpack_public_path__ + "d3a68c19b54661f1be50.worker.js");
};